<template>
  <div class="appoint-rule-dialog" v-if="visible">
    <div class="dialog-content">
      <i class="icon icon-close" @click="closeDialog"></i>
      <i class="rule-bg"></i>
      <div class="rule-body">
        <div class="rule-title">活动规则介绍</div>
        <div class="each-rule" v-for="(item, index) of rulesInfo" :key="index">
          <div class="rule-item">{{item.tit}}</div>
          <div class="rule-section" v-for="(ele, ind) of item.info" :key="ind">{{ele}}</div>
          <div class="rule-mult" v-for="(mult, midx) of item.multipleInfo" :key="'midx' + midx">{{mult}}</div>
          <div class="rule-tips" v-if="item.tips"><span class="tip-imp">*</span>{{item.tips}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DialogMixins from '@/mixins/DialogMixins'
import { THIS_TIME } from '../constans'
export default {
  mixins: [DialogMixins],
  data() {
    return {
      rulesInfo: [
        {
          tit: '活动简介',
          info: [
            '只要你是芒果TV用户，就可以尊享参与《朋友请听好》预约活动，并有机会参与节⽬直播连线哦',
            '我们将在每期预约成功的⽤户中，抽取一千名幸运听众，有机会与节⽬目嘉宾进⾏广播站直播连线，解决你的烦恼，分享你的故事! ',
            
          ],
          multipleInfo: [
            `本次预约时间:${THIS_TIME}`,
            '中选用户公布:请关注@朋友请听好 官⽅微博',
            '本次直播时间:请关注官博'
          ],
          tips: '中选用户会收到手机短信，直播热线号码会以短信形式发送给中选用户，一切信息以手机短信为准',
        },
        {
          tit: '其他注意事项',
          info: [
            '1.本活动由芒果TV研制开发，与苹果公司APPLE.INC⽆无关',
            '2.本活动最终解释权归湖南快乐阳光互动娱乐传媒有限公司',
          ],
        }
      ]
    }
  },
}
</script>
<style lang="scss">
@import "~@/assets/mixins.scss";

.appoint-rule-dialog{
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(11, 11, 11, 0.52);
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;

  .dialog-content{
    position: relative;
    max-height: 90%;
    overflow-y: auto;
    @include px2vw(width, 574);
    @include px2vw(min-height, 500);
    @include px2vw(padding-top, 30);
    @include px2vw(padding-bottom, 30);
    @include px2vw(font-size, 24);
    background-color: #fff;

    .rule{
      &-bg{
        position: absolute;
        z-index: 1;
        left: 0;
        @include px2vw(top, 84);
        @include px2vw(width, 127);
        @include px2vw(height, 273);
        background-image: url("~@/assets/img/comma-bg.png");
        background-size: 100% 100%;
      }
      &-body{
        position: relative;
        z-index: 10;
        @include px2vw(padding-left, 13);
        @include px2vw(padding-right, 13);

        .each-rule{
          @include px2vw(margin-bottom, 54);
        }
      }
      &-title{
        margin: 0 auto;
        @include px2vw(margin-bottom, 40);
        @include px2vw(width, 272);
        @include px2vw(height, 82);
        @include px2vw(line-height, 62);
        @include px2vw(font-size, 30);
        background-image: url("~@/assets/img/rule-title.png");
        background-size: 100% 100%;
        color: #fff;
        text-align: center;
      }
      &-item{
        margin: 0 auto;
        @include px2vw(margin-bottom, 45);
        @include px2vw(width, 210);
        @include px2vw(height, 62);
        @include px2vw(line-height, 62);
        @include px2vw(border-radius, 11);
        @include px2vw(border-width, 3);
        border-color: #648AFA;
        border-style: solid;
        @include px2vw(font-size, 28);
        text-align: center;
        color: #000;
        background-color: rgba(102, 141, 247, 0.37);
      }
      &-section{
        @include px2vw(margin-bottom, 30);
        @include px2vw(font-size, 26);
        line-height: 1.5;
      }
      &-mult{
        @include px2vw(font-size, 26);
        line-height: 1.5;
      }
      &-tips{
        @include px2vw(margin-top, 30);
        @include px2vw(font-size, 24);
        .tip-imp{
          color: #eb4a41;
        }
      }
    }
  }
}
.icon{
  &-close{
    position: absolute;
    z-index: 100;
    @include px2vw(right, 15);
    @include px2vw(top, 15);
  }
}
</style>